<template>
  <div>
    <div class="reviews d-none d-md-block">
      <div class="reviews__list">
        <div class="reviews__slider">
          <div
            v-for="(slide, i) in items"
            :key="slide.company"
            class="review"
            :class="{ active: activeSlide === i }"
          >
            <div class="review__text my-5">
              {{ slide.content }}
            </div>
            <div class="font-weight-bold">
              {{ slide.name }}
            </div>
            <div>{{ slide.position }}</div>
          </div>
        </div>
      </div>
      <svg
        class="reviews__arrow reviews__prev"
        width="22"
        height="49"
        viewBox="0 0 22 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="slider(false)"
      >
        <path d="M21 48L1 24L21 1" stroke="black" stroke-opacity="0.5" />
      </svg>
      <svg
        class="reviews__arrow reviews__next"
        width="22"
        height="49"
        viewBox="0 0 22 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="slider(true)"
      >
        <path d="M1 48L21 24L0.999998 1" stroke="black" stroke-opacity="0.5" />
      </svg>
    </div>
    <VCarousel
      v-model="activeSlide"
      hide-delimiter-background
      :show-arrows="false"
      class="d-md-none"
      height="460"
      light
    >
      <VCarouselItem
        v-for="slide in items"
        :key="slide.key"
      >
        <div class="review__text my-5">
          {{ slide.content }}
        </div>
        <div class="font-weight-bold">
          {{ slide.name }}
        </div>
        <div>{{ slide.position }}</div>
      </VCarouselItem>
    </VCarousel>
  </div>
</template>

<script>
export default {
  name: 'Reviews',
  data() {
    return {
      activeSlide: 0,
      activeDesktop: 0,
    };
  },
  computed: {
    items() {
      return [
        {
          content: this.$t('content1'),
          name: this.$t('name1'),
          position: this.$t('position1'),
        },
        {
          content: this.$t('content2'),
          name: this.$t('name2'),
          position: this.$t('position2'),
        },
        {
          content: this.$t('content3'),
          name: this.$t('name3'),
          position: this.$t('position3'),
        },
        {
          content: this.$t('content4'),
          name: this.$t('name4'),
          position: this.$t('position4'),
        },
        {
          content: this.$t('content5'),
          name: this.$t('name5'),
          position: this.$t('position5'),
        },
        {
          content: this.$t('content6'),
          name: this.$t('name6'),
          position: this.$t('position6'),
        },
        {
          content: this.$t('content7'),
          name: this.$t('name7'),
          position: this.$t('position7'),
        },
        {
          content: this.$t('content8'),
          name: this.$t('name8'),
          position: this.$t('position8'),
        },
        {
          content: this.$t('content9'),
          name: this.$t('name9'),
          position: this.$t('position9'),
        },
        {
          content: this.$t('content10'),
          name: this.$t('name10'),
          position: this.$t('position10'),
        },
      ];
    },
  },
  methods: {
    slider(sign) {
      if (sign && this.activeDesktop < this.items.length / 2 - 1) {
        this.activeDesktop += 1;
      } else if (!sign && this.activeDesktop > 0) {
        this.activeDesktop -= 1;
      } else {
        return false;
      }
      const root = document.querySelector('.reviews');
      root.style.setProperty('--margin', `-${100 * this.activeDesktop}%`);
      return true;
    },
    swipeIt(e) {
      switch (e) {
        case 'left':
          // eslint-disable-next-line max-len
          this.activeSlide = this.activeSlide < this.items.length - 1 ? this.activeSlide + 1 : this.activeSlide;
          break;
        case 'right':
          // eslint-disable-next-line max-len
          this.activeSlide = this.activeSlide > 0 ? this.activeSlide - 1 : this.activeSlide;
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss">
.reviews {
  .v-slide-group__prev,
  .v-slide-group__next {
    display: none;
  }
  --margin: 0;
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    .review:first-child {
      margin-left: var(--margin);
    }
  }
}
</style>
<style scoped lang="scss">
.reviews {
  display: flex;
  overflow: hidden;
  position: relative;
  &__list {
    overflow: hidden;
  }
  &__slider {
    display: flex;
    transition: 0.3s;
    position: relative;
  }
  &__arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    display: none;
  }
  &__prev {
    left: 10px;
  }
  &__next {
    right: 10px;
  }
}
div.review__logo {
  width: 80px;
  height: 80px;
  background: #b8b8b8;
  border-radius: 50%;

  svg {
    width: 70%;
    height: 70%;
  }
}
.review {
  width: calc(100vw - #{$spacer * 7});
  padding-right: $spacer * 7;
  flex: 0 0 auto;
  white-space: initial;
  box-sizing: border-box;
  transition: 0.3s;
  &:not(.active) {
    display: none;
  }
}


@media #{map-get($display-breakpoints, 'md-and-up')} {
  .reviews {
    padding: 0 50px;
    &__arrow {
      display: block;
    }
  }
  .review {
    padding: 0 50px;
    width: 50%;
    position: relative;
    &:not(.active) {
      display: block;
    }
    &:nth-child(odd) {
      &:after {
        content: '';
        position: absolute;
        top: 20px;
        bottom: 10px;
        right: 0;
        border-right: 1px solid rgba(196, 196, 196, 0.5);
      }
    }
  }
}
@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .review {
    padding: 0 120px;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .review__logo {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .review {
    &__text {
      font-size: 0.9375rem;
    }
  }
}
</style>

<!-- eslint-disable max-len -->
<i18n locale="en" lang="yaml">
  content1: I used to evaluate every candidate personally. The procedure took a lot of time and effort to set up the interviews. Now, my HR department can do all the initial interviews and send me the recordings of worthy candidates for my approval. The recruitment process now depends less on my schedule and has become easier for both our current staff and potential employees.
  name1: Mark Morrison
  position1: software company
  content2: Our school of foreign languages always has a couple of job openings. Huntica saves us the expense of having a multilingual HR department because Huntica’s virtual interviewers can ask questions in any language while our HR staff can review the recorded interviews in their own native languages. It saves our school a lot of resources.
  name2: Jessica Bromfield
  position2: language school
  content3: Once a year we hold a music festival and hire dozens of temporary workers and volunteers. This hiring process is extremely time-consuming and requires more recruiters than we have. Huntica is like an extra human resources office for that busy period. They interview the candidates and fill the positions. We focus on our passion - music.
  name3: Robert Chang
  position3: concert hall
  content4: One recruiter is now enough to equip our pharmacy chain with great personnel. Huntica completes most of recruitment tasks, leaving decision-making and final live interviews to the recruiter. We have reduced our expenses by a lot without sacrificing quality.
  name4: Laura Torres
  position4: pharmacy
  content5: What a breath of fresh air! With this platform, hundreds of auditions for commercials are handled without effort — all in a way that is easy to store and share with the production team. Huntica’s site is well organized and easy to use, especially for new team members.
  name5: Susie Robinson
  position5: advertising company
  content6: In 2020, we had to expand our lab dramatically in order to run more lab tests. When we reached the limit of our HR team’s capacity, we decided to change our approach and automate it as much as possible. With Huntica, our HR managers now have enough time for important tasks like shortlisting candidates after virtual interviews and conducting final interviews live. Everything else is handled for them.
  name6: John Flynn
  position6: medical testing company
  content7: When opening a new office, we needed to hire new team members in different time zones. This meant that the recruiters from our headquarters couldn’t interview candidates efficiently. While we were looking for a way around this issue, we found Huntica with their virtual interviewer. It saved us from big changes in our human resources team while helping us to fill these new positions.
  name7: Chris Cornwell
  position7: tech start-up
  content8: Our candidates are more likely to use smartphones than laptops, and so we looked for a handy interview solution for mobile users. With Huntica, we increased the efficiency and quality of our remote interviews with a seamless experience for our candidates and HR.
  name8: Drew Williams
  position8: transportation company
  content9: All our offices switched to virtual interviews to save time and money. We tested out several platforms and chose Huntica as it has a more ‘human’ feel than the other options. Our candidates like the interview process and we like the way Huntica organizes candidates’ information.
  name9: Thomas Jenkins
  position9: furniture shop
  content10:  We recruit online trainers, and it is important for us to see a candidate do a demo lesson and assess how they act when they are live. With Huntica, every candidate has to record their interview in real-time and there is no way to edit their answers afterward. For us, this is a much better way of evaluating our candidates virtually
  name10: Michelle Roth
  position10: online fitness platform
</i18n>

<i18n locale="ru" lang="yaml">
  content1:  Нам удалось оптимизировать процесс поиска нового директора по развитию с помощью Huntica. Обычно на должность такого уровня у нас требуется согласование в несколько этапов. У Huntica есть возможность отправить запись интервью коллегам, которые участвуют в процессе согласования. Таким образом, успешные кандидаты теперь проходят только 2 интервью - первое интервью через Huntica и финальное живое интервью с руководством компании.
  name1: Григорий Калинин
  position1: производственная компания
  content2: Как небольшая частная стоматология, мы не часто открываем вакансии и не имеем рекрутера в штате. Сервис с виртуальным рекрутером - это отличное решение для нас. Huntica полностью покрывает наши потребности, и мы эффективно находим новых сотрудников, не прибегая к услугам кадровых агентств.
  name2: Екатерина Новосельцева
  position2: стоматология
  content3: С Huntica мы успешно закрыли вакансию администратора интернет-магазина. От сотрудника мы ожидали открытость новому и способность быстро адаптироваться, поэтому использование необычного формата собеседования показалось нам хорошей идеей. Первичное собеседование с Huntica действительно позволило отсеять кандидатов, не готовых для этой должности.
  name3: Дмитрий Гусев
  position3: инернет-магазин
  content4: Мы смогли значительно сократить количество HR менеджеров в нашем call-центре, заменив предварительный звонок кандидату на короткое первичное интервью. Теперь HR менеджеры не проводят интервью, а только оценивают записи собеседований. С большим потоком кандидатов это существенная экономия ресурсов.
  name4: Анастасия Маркова
  position4: аутсорсинговый call-центр
  content5: С переходом на удаленный формат интервью мы решили пойти дальше и автоматизировали процесс собеседования. Мы хотели, чтобы для кандидатов такой переход оказался максимально безболезненным, и в итоге остановились на Huntica как самом простом и человечном сервисе среди русскоязычных вариантов. С такой автоматизацией мы экономим время наших сотрудников без потери результата.
  name5: Светлана Шевченко
  position5: издательство
  content6: Мы давно искали решение, которое позволило бы нам не привязывать время проведения интервью к рабочим часам HR менеджеров. Мы внедрили Huntica на несколько недель в тестовом режиме и поняли, что это позволяет кандидатам пройти собеседование быстрее, не дожидаясь удобного свободного времени в рабочие часы отдела кадров. Это очень важно, так как наши кандидаты часто работают в другом графике.
  name6: Сергей Вишневский
  position6: клининговая компания
  content7: Иногда нам приходится набирать одновременно несколько сотрудников, которые нужны в кратчайшие сроки. Huntica позволяет справиться с неравномерной потребностью в HR менеджерах. Кроме этого, Huntica может задать вопросы на иностранном языке, чтобы проверить знание языка уже на первом собеседовании.
  name7: Анна Кравец
  position7: агентство переводов
  content8: Раньше мы всегда проводили собеседования преподавателей удаленно — мы просили кандидатов записать видео с ответами на несколько вопросов о себе. Нам не всегда нравился результат такого отбора, так как кандидаты могли записывать много дублей. С Huntica мы упростили процесс записи интервью и сократили количество дублей до одного.
  name8: Надежда Чистякова
  position8: онлайн-школа
  content9: Для нас было важно найти сервис для собеседований, который работает одинаково хорошо и с телефона, и с компьютера. Большая часть наших кандидатов предпочитает использовать смартфон для собеседований в удаленном формате. С Huntica кандидаты сами могут выбрать удобное для них устройство и пройти собеседование в любое время.
  name9: Анастасия Зубкова
  position9: курьерская служба
  content10: Мы использовали Huntica для подбора сотрудников на 3 должности разного уровня. Huntica оказалась очень удобным инструментом для всех вакансий, независимо от сферы и требований к кандидатам
  name10: Евгения Мартынова
  position10: рекламное агентство
</i18n>

<!-- eslint-enable max-len -->
